var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.mainWrapperClass }, [
    _c("div", { class: _vm.$modal.modalContent }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.formAction($event)
            }
          }
        },
        [
          _c("v-flex", [
            _c("p", { class: _vm.$modal.modalText }, [
              _vm._v(
                "\n          If you’ve saved your number with our kiosk before,\n          or would like to create an account, enter your phone number below:\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { class: _vm.$modal.modalInput },
            [
              _c("InputField", {
                class: ((_obj = {}),
                (_obj[_vm.$modal.errorField] = _vm.$v.phone.$error),
                _obj),
                attrs: {
                  "return-masked-value": false,
                  mask: "(###) ### - ####",
                  placeholder: "(xxx) xxx - xxxx",
                  label: "Phone Number*",
                  type: "tel"
                },
                model: {
                  value: _vm.$v.phone.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.phone, "$model", $$v)
                  },
                  expression: "$v.phone.$model"
                }
              }),
              _vm._v(" "),
              _vm.$v.phone.$error
                ? _c("p", { class: _vm.$modal.errorMessage }, [
                    _vm._v("\n          Phone is required\n        ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errors
                ? _c("p", { class: _vm.$modal.errorMessage }, [
                    _vm._v("\n          " + _vm._s(_vm.errors) + "\n        ")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", [
            _c("p", { class: _vm.$modal.legalText }, [
              _vm._v(
                "\n          The phone number provided to burger boss\n          will only be used for account identification.\n          It will not be shared in any way shape\n          or form with any 3rd party companies\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.isMobilePlatform
            ? _c(
                "MobileButton",
                {
                  class: _vm.$modal.mobileBtn,
                  attrs: { disabled: _vm.pending },
                  on: { click: _vm.formAction }
                },
                [_vm._v("\n        Submit\n      ")]
              )
            : _c(
                "v-flex",
                { class: _vm.$modal.modalButtons },
                [
                  _c(
                    "BaseButton",
                    {
                      class: _vm.$modal.submitBtn,
                      attrs: { "button-style": "Main", disabled: _vm.pending },
                      on: { click: _vm.formAction }
                    },
                    [_vm._v("Submit")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class: _vm.$modal.cancelBtn,
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/auth/components/SignIn.vue?vue&type=template&id=673cdac8&
// module id = null
// module chunks = 